import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { Table, TableModule, TablePageEvent } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { MultiSelectModule } from 'primeng/multiselect';
import { Observable } from 'rxjs/internal/Observable';
import { ToggleButtonModule } from 'primeng/togglebutton';
import PagingModel from '../../../global/model/PagingMoel';
import {
  SearchModel,
  DisplayColumn,
  LookupItem,
  LookupFilter,
  FilterModel,
} from '../../../global/model/SearchModel';
import { ConfirmationService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { SearchService } from '../../../global/services/data/search-service/searchservice';
import { GenericButtonComponent } from '../../../global/component/generic/generic-button/generic-button.component';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { AddDonationService } from '../../../vortex/services/add-donation.service';
import { Router } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { DOCUMENT } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { GenericTextInputComponent } from '../../../global/component/generic/generic-text-input/generic-text-input.component';
import { LoadingSpinnerComponent } from '../../../global/component/loading-spinner/loading-spinner.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FormControl } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { DonorCardComponent } from '../../../vortex/page/donor-card/donor-card.component';
import { MainModel } from '../../../global/model/MainModel';
import { ServerClientService } from '../../../global/services/data/campaign-service/server-client.service';
import { DonationCardComponent } from "../donation-card/donation-card.component";
import { DonationsAddComponent } from "../donations-add/donations-add.component";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SearchCacheService } from '../../services/searchcache.service';
import { catchError, of, tap } from 'rxjs';
import { MatchType } from '../../../global/model/search/MatchType';
import { TableFilterComponent } from "../../../global/component/generic/table-filter/table-filter.component";
import { exportToExcel } from '../../../global/util/util';
import Campaign from "../../../global/model/Campaign";
interface ExportColumn {
  title: string;
  dataKey: string;
}

@Component({
  selector: 'app-donations-search',
  standalone: true,
  imports: [
    TableModule,
    CommonModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    MultiSelectModule,
    ToggleButtonModule,
    MenuModule,
    GenericButtonComponent,
    ToastModule,
    DonorCardComponent,
    TagModule,
    InputGroupModule,
    InputIconModule,
    IconFieldModule,
    CardModule,
    GenericTextInputComponent,
    LoadingSpinnerComponent,
    OverlayPanelModule,
    DonationCardComponent,
    DonationsAddComponent,
    ConfirmDialogModule,
    TableFilterComponent
],
  providers: [MessageService, AddDonationService, ConfirmationService],
  templateUrl: './donations-search.component.html',
  styleUrl: './donations-search.component.scss',
})
export class DonationsSearchComponent implements OnInit {
  @Output() cancelEvent = new EventEmitter<void>();

  @ViewChild('resultstable')
  resultstable!: Table;
  dataObject!: Observable<unknown>;
  dataElements: Array<any> = [];
  isFullscreen: boolean = false;
  cols!: DisplayColumn[];
  exportColumns: ExportColumn[] = [];
  selectedStates: string[] = [];
  selectedFundCodes: number[] = [];
  selectedFundraisers: number[] = [];
  selectedSources: number[] = [];
  selectedEvents: number[] = [];
  selectedStatus: string[] = [];
  selectedApproval: string[] = [];
  defaultColumns: DisplayColumn[] = [];
  groupedOptions: any[] = [];
  selectedColumns: DisplayColumn[] = [];
  defaultCmmonFilters: SelectItem[] = [];
  defaultAmountFilter: SelectItem[] = [];
  states: LookupItem[] = [];
  fundCodes: LookupItem[] = [];
  fundraisers: LookupItem[] = [];
  sources: LookupItem[] = [];
  events: LookupItem[] = [];
  statuses: LookupItem[] = [];
  approvals: LookupItem[] = [];
  rawData: any[] = [];
  totalData: any[] = [];
  approvalsData: any[] = [];
  selectedOptions: MenuItem[] = [];
  isExpanded = false;
  hasAmountFilter=false;      
  hasDateFilter=false;
  campaignId: number = -1;
  maxSelectedLabels = this.isExpanded ? 100 : 10;
  balanceFrozen: boolean = true;
  showScrollFilters: boolean = false;
  filters: Array<string> = [];
  selectedRows: any[] = [];
  showLoading: boolean = false;
  searchClicked: boolean = false;
  filterValue: FormControl = new FormControl('');
  visibleDonorGivingHistory: boolean = false;
  showDialog: boolean = false;
  isFilterActive: boolean = false;
  showAddDonationCardDialog: boolean = false;
  selectedDonorId: any;
  selectedDonationId: any;
  textFilters: { [key: string]: string } = {};
  lkpCheckbooks: LookupItem[] = [];
  showAddDonationsButton: boolean = false;
  message: string = "No results found. Please review your filters and try again";
  searchMessage: string = "Try using Quick Search or updating the filters above to find your donations.";
  NoDataMessage: string = this.searchMessage;

  @Input() searchPageId: string = 'donations';
  @Input() showInDialog: boolean = false;
  @Input() selectedSearchArea: any = null;
  @Input() searchKeyword: string = '';

  //inputs...
  @Input({ required: true }) pagingModel: PagingModel = new PagingModel();
  @Input({ required: true }) columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    fundraisers: [],
    sources: [],
    events: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    batchTypes: [],
    checkbooks: [],
    dateFilters: [],
  };

  // outputs
  @Output() dataViewUpdate = new EventEmitter<PagingModel>();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private serverClient: ServerClientService,
    private servicesearch: SearchService,
    private searchCache: SearchCacheService,
    private messageService: MessageService,
    private router: Router,
    private mainModel: MainModel,
    private confirmationService: ConfirmationService ){
      this.fetchCampaignId();
    }

    private fetchCampaignId(): void {
      const selectedCampaign = this.mainModel.selectedCampaign();
      if (!selectedCampaign) {
        this.mainModel.fetchSelectedCampaign().subscribe({
          next: (campaign: Campaign) => {
            this.mainModel.setSelectedCampaign(campaign);
            this.campaignId = campaign.campaignId;
            this.bindDefaults();
          },
          error: (err) => {
            console.error('Failed to fetch selected campaign:', err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to fetch the selected campaign. Please try again later.',
              life: 5000,
            });
          },
        });
      } else {
        this.campaignId = selectedCampaign.campaignId;
        this.bindDefaults();
      }
      
    if (isNaN(this.campaignId as number)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Campaign ID',
        detail: 'The selected campaign ID is invalid. Please select a valid campaign.',
        life: 5000,
      });
    }
    }

  hasNoResults = () => !this.rawData || this.rawData.length === 0;

  resetFilters() {
    this.resultstable.clear();
    this.selectedStates = [];
    this.selectedFundCodes = [];
    this.selectedFundraisers = [];
    this.selectedSources = [];
    this.selectedEvents = [];
    this.rawData = [];
    this.searchClicked = false;
    this.textFilters = {};
    this.filterValue.patchValue(null);
    this.NoDataMessage = this.searchMessage;
    this.showAddDonationsButton= false;
    this.isFilterActive= false;
    this.searchCache.clear('Donation-search');
    this.selectedColumns.forEach(i => {
      if (i.filterModel.options?.length ||
        (i.displayColumnType.columnType === "AmountFilter" || i.displayColumnType.columnType === "DateFilter")) {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "equals";
      } else {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "contains";
      }
    });
  }
  pageForward() {
    (
      this.document.getElementsByClassName(
        'p-paginator-next'
      )[0] as HTMLAnchorElement
    ).click();
  }

  pageBack() {
    (
      this.document.getElementsByClassName(
        'p-paginator-prev'
      )[0] as HTMLAnchorElement
    ).click();
  }

  toggleSelectedLabels() {
    this.isExpanded = !this.isExpanded;
    this.maxSelectedLabels = this.isExpanded ? 100 : 10;
    this.selectedColumns = [...this.selectedColumns];
  }

  updatePagingModel(start: number, maxResults: number = 10) {
    const pModel: PagingModel = this.pagingModel;
    pModel.maxResults = maxResults;
    pModel.startRow = start;
    // we emit and the service call should inject a new model...
    this.dataViewUpdate.emit(pModel);
  }

  pageChange(event: TablePageEvent) {
    this.updatePagingModel(event.first, event.rows);
  }

  ngOnInit() {
  }
  
  bindDefaults() {
    this.filterValue.setValue(this.searchKeyword);
    this.selectedOptions = [
      {
        label: 'Approve my Expenses',
        icon: 'fa-sharp fa-light fa-user-check',
        command: () => '',
      },
      {
        label: 'Send for Payment',
        icon: 'fa-sharp fa-light fa-envelope-open-dollar',
        command: () => '',
      },
      {
        label: 'Delete',
        icon: 'fa-sharp fa-light fa-trash-can',
        command: () => '',
      },
    ];
    this.initializeColumns().subscribe(()=>{
      const saved = this.searchCache.get('Donation-search');
    
      if (saved && saved.query) {
        const filters = saved.query;
        this.isFilterActive= saved.isFilterActive;


        this.selectedStates = this.states
          .filter(s => filters['states']?.values?.includes(s.key))
          .map(s => s.value);
      
          if (this.fundCodes?.length > 0 && filters['fundcode']?.values) {
            this.selectedFundCodes = this.fundCodes
              .filter(f => filters['fundcode']?.values?.includes(f.key))
              .map(f => f.key as number);
          }
      
          if (this.sources?.length && filters['source']?.values?.length) {
            this.selectedSources = this.sources
              .filter(s => filters['source'].values.includes(s.key))
              .map(s => s.key as number);
          }
          
          if (this.events?.length && filters['eventcode']?.values?.length) {
            this.selectedEvents = this.events
              .filter(e => filters['eventcode'].values.includes(e.key))
              .map(e => e.key as number);
          }
          
          if (this.fundraisers?.length && filters['fundraiser']?.values?.length) {
            this.selectedFundraisers = this.fundraisers
              .filter(f => filters['fundraiser'].values.includes(f.key))
              .map(f => f.key as number);
          }

        for (const key in filters) {
          const filterEntry = filters[key];
          if (filterEntry && typeof filterEntry === 'object' && 'value' in filterEntry && 'matchMode' in filterEntry) {
            this.textFilters[key] = filterEntry.value ?? '';
          }
        }

        const savedAmountFilter = saved.query['Amount'];
        if (savedAmountFilter && savedAmountFilter.Value) {
          const targetColumn = this.selectedColumns.find(col => col.columnName === 'Amount');
          if (targetColumn) {
            targetColumn.filterModel.from = savedAmountFilter.Value;
            targetColumn.filterModel.op= savedAmountFilter.MatchMode;
              if(savedAmountFilter.MatchMode === 'between') {
                  targetColumn.filterModel.op = 'between';
                  targetColumn.filterModel.isMenuOpen = true;
                  targetColumn.filterModel.to = savedAmountFilter.RangeEnd;
              }
          }
        }

        const savedDateFilter = saved.query['Date'];
        if (savedDateFilter && savedDateFilter.Value) {
          const targetColumn = this.selectedColumns.find(col => col.columnName === 'Date');
          if (targetColumn) {
            const parsedDate = new Date(savedDateFilter.Value);
            if (!isNaN(parsedDate.getTime())) {
              targetColumn.filterModel.from = this.formatDateToMMDDYYYY(parsedDate);
              if(savedDateFilter.MatchMode === 'between') {
                const parsedEndDate = new Date(savedDateFilter.RangeEnd);
                if (!isNaN(parsedEndDate.getTime())) {
                  targetColumn.filterModel.op = 'between';
                  targetColumn.filterModel.isMenuOpen = true;
                  targetColumn.filterModel.to = this.formatDateToMMDDYYYY(parsedEndDate);
                }
              }
            }
          }
        }

        this.resultstable.filters = filters;
        this.onSearch();
      }
    });
  }

  ngOnChanges() {
    this.fetchCampaignId();
  }

  ngAfterViewInit():void {

    if (this.searchKeyword) {
      this.onSearch();
    }
  }
 
  onPageSearch() {
    if (!this.filterValue?.value?.trim()) {
        this.messageService.add({
        severity: 'error',
        summary: 'Keyword Required',
        detail: 'Please enter a keyword to use the Quick Search.',
      });
	  }
    else
     this.onSearch();
  }
  
  private initializeColumns():Observable<any> {
  return  this.serverClient.getDataTableData('donations', undefined, this.campaignId).pipe(
      tap((data: SearchModel) => {
        this.columnData = data;
        this.defaultColumns = this.columnData && this.columnData.displayColumns ? this.columnData.displayColumns : [];
        if (this.defaultColumns)
          this.groupedOptions = this.groupColumnsBy('groupByColumn');
        this.selectedColumns =  this.columnData && this.columnData.displayColumns ? this.columnData.displayColumns.filter((x) => x.isDefault) : [];
        //  'DepositBatchID'
        // this.multiSelectedColumns=  this.selectedColumns ?  this.selectedColumns = this.selectedColumns.filter(
        //   column => column.columnName !== 'DepositBatchID'
        // ) :  this.selectedColumns; 
        this.defaultCmmonFilters =  this.columnData && this.columnData.commonFilters ? this.convertLookupItemsToSelectItems( this.columnData.commonFilters ) : [];
        this.defaultAmountFilter = this.columnData && this.columnData.amountFilters ? this.convertLookupItemsToSelectItems( this.columnData.amountFilters) : [];
        this.states = (this.columnData && this.columnData.states) || [];
        this.fundCodes = (this.columnData && this.columnData.fundCodes) || [];
        this.fundraisers = (this.columnData && this.columnData.fundraisers) || [];
        this.sources = (this.columnData && this.columnData.sources) || [];
        this.events = (this.columnData && this.columnData.events) || [];
        this.lkpCheckbooks = data && data.checkbooks || [];
        this.statuses = (this.columnData && this.columnData.statusOptions) || [];
        data.displayColumns.forEach((i: DisplayColumn) => {
          i.filterModel = this.getBlankFilter(i);
        });
        this.cols = this.selectedColumns || [];
        this.exportColumns = this.cols.map((col: any) => ({title: col.header, dataKey: col.field}));
      }),
      catchError(err => {
        console.error('Error loading donation batch columns:', err);
        return of(null);
      })
  );
  }

  private convertLookupItemsToSelectItems(
    lookupItems: LookupFilter[]
  ): SelectItem[] {
    return lookupItems.map((item: LookupFilter) => ({
      value: item.value,
      label: item.label,
    }));
  }

  groupColumnsBy(groupByField: keyof DisplayColumn) {
    const excludedHeaders = ['BatchProcessed', 'DepositBatchID'];
    const groups: any = {};
    this.defaultColumns.forEach((column) => {
      if (excludedHeaders.includes(column.columnName)) { return; }
      const group = column[groupByField] as string;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(column); // Pass entire DisplayColumn object as value
    });

    return Object.keys(groups).map((group) => ({
      label: group,
      items: groups[group],
    }));
  }

  getMatchMode(columnType: string): string {
    if (columnType === 'TextFilter' || columnType === 'IDFilter')
      return 'equals';
    if (columnType === 'AmountFilter') return 'gt';
    else return 'startsWith';
  }

  restrictNonNumeric(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }
  onSearch() {
    this.showLoading = true;
    const filterData = this.buildFilterData(this.resultstable.filters);
    const data = JSON.parse(filterData);
    const hasSearchTextFilter = !!this.filterValue?.value?.trim();
    const isEmptyStates = Array.isArray(data.states?.values) && data.states.values.length === 0;
    const isEmptyFundCodes = Array.isArray(data.fundcode?.values) && data.fundcode.values.length === 0;
    const isEmptySources  = Array.isArray(data.source?.values) && data.source.values.length === 0;
    const isEmptYEventCodes  = Array.isArray(data.eventcode?.values) && data.eventcode.values.length === 0;
    const isEmptyFundRaisers = Array.isArray(data.fundraiser?.values) && data.fundraiser.values.length === 0;
    const isEmptyTextFilters =   this.textFilters === null || Object.values(this.textFilters).every(value => value.trim() === '');
    const hasSearchDateTextFilter= !!(data.Date?.Value?.trim());
    const hasSearchAmountTextFilter= !!(data.Amount?.Value?.trim());
    
    if (!hasSearchTextFilter && isEmptyStates &&isEmptySources && isEmptYEventCodes && isEmptyFundRaisers && isEmptyFundCodes
       && isEmptyTextFilters && !data.Amount?.value?.trim() && !hasSearchDateTextFilter && !hasSearchAmountTextFilter) {
      this.messageService.add({
        severity: 'error',
        summary: 'Filter Required',
        detail: 'Please select at least one filter before starting the search.',
      });
      this.showLoading = false;
    } else {
      const c: any = this.mainModel.selectedCampaign();
      const campaignId = parseInt(c?.campaignId);
      this.loadFilteredData(campaignId, filterData);
    }
  }

  private buildFilterData(filters: { [key: string]: any }): string {
    if (this.selectedStates && this.selectedStates.length > 0) {
      filters['states'] = {
        values: this.states
          .filter((state) => this.selectedStates.includes(state.value))
          .map((state) => state.key),
      };
    } else {
      filters['states'] = { values: [] };
    }
  
    if (this.selectedFundCodes && this.selectedFundCodes.length > 0) {
      filters['fundcode'] = {
        values: this.fundCodes
          .filter(fundcode => this.selectedFundCodes.includes(fundcode.key as number))
          .map((fundcode) => fundcode.key),
      };
    }
    else {
      filters['fundcode'] = { values: [] };
    }

    if (this.selectedSources && this.selectedSources.length > 0) {
      filters['source'] = {
        values: this.sources
          .filter(s => this.selectedSources.includes(s.key as number))
          .map((s) => s.key),
      };
    }
    else {
      filters['source'] = { values: [] };
    }

    if (this.selectedEvents && this.selectedEvents.length > 0) {
      filters['eventcode'] = {
        values: this.events
          .filter(s => this.selectedEvents.includes(s.key as number))
          .map((s) => s.key),
      };
    }
    else {
      filters['eventcode'] = { values: [] };
    }

    if (this.selectedFundraisers && this.selectedFundraisers.length > 0) {
      filters['fundraiser'] = {
        values: this.fundraisers
          .filter(f => this.selectedFundraisers.includes(f.key as number))
          .map((f) => f.key),
      };
    }
    else {
      filters['fundraiser'] = { values: [] };
    }

    for (const key in this.textFilters) {
      if(key !== "State") {
        if (this.textFilters[key]?.trim()) {
          filters[key] = {
            value: this.textFilters[key].trim(),
            matchMode: 'contains'
          };
         } else {
          filters[key] = {
            value: null,
            matchMode: 'contains'
          };
        }
      } 
    }

     // Range Filter
     this.selectedColumns.forEach(
      (item: DisplayColumn) => {
        const { filterModel } = item;
        const isEmpty =
          filterModel.from === null ||
          filterModel.from === undefined ||
          (typeof filterModel.from === 'string' && filterModel.from.trim() === '') ||
          (Array.isArray(filterModel.from) && filterModel.from.length === 0);

        if (!isEmpty) {
          const filter: MatchType = new MatchType();
          filter.Value = filterModel.from;
          filter.MatchMode = filterModel.op;

          if (filterModel.to !== null && filterModel.to !== undefined && filterModel.to !== '') {
            filter.RangeEnd = filterModel.to;
          }

          filters[item.columnName] = filter;
        }
        else if (filters[item.columnName] && filters[item.columnName].matchMode?.length) {
          console.debug(filters[item.columnName]);
        }
        else {
          delete filters[item.columnName];
        }
      }
    )
    
    const c: any = this.mainModel.selectedCampaign();
    const campaignId = parseInt(c?.campaignId);
    this.searchCache.save('Donation-search', { query: filters, isFilterActive: this.isFilterActive, campaignId: campaignId});
    return JSON.stringify(filters);
  }
  formatDateToMMDDYYYY(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
  private loadFilteredData(campaignId: number, filterData: string) {
    this.showLoading = true;
    this.rawData = [];
    this.router.url;
    this.servicesearch.getDonationSearchData(campaignId,this.filterValue?.value ?? null, filterData ).subscribe({
      next: (data: any[]) => {
        this.showLoading = false;
        this.rawData = data;
        this.resultstable.reset();
        this.showAddDonationsButton= true;
        if(data.length === 0 )
          this.NoDataMessage = this.searchClicked? this.message : this.searchMessage;
      },
      error: (error: any) => {
        this.showLoading = false;
        this.showAddDonationsButton= false;
        console.error('API Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Retrieval Error',
          detail: 'We were unable to retrieve data. Please try again or contact support if the issue continues.',
          life: 7500,
        });

      },
    });
  }

  

  onExportToExcel() {
    const excludedHeaders = ['BatchProcessed', 'DepositBatchID'];
    const fields = this.selectedColumns
      .filter((col: any) => !excludedHeaders.includes(col.columnName))
      .map(col => col.columnName);
    
    const dataToExport = this.resultstable.value.map((row) => {
      const filteredRow: any = {};
      fields.forEach((field) => {
        let value = row[field];
        if (field === "Date" && value) { value = new Date(value).toLocaleDateString(); }
        if (field === "Amount" && value) { value = parseFloat(value).toFixed(2); }
        filteredRow[field] = value !== undefined && value !== null ? value : "";
      });
      return filteredRow;
    });

    exportToExcel(dataToExport,"Donation Search");
  }

  isSearchActive(): boolean {
    return this.rawData.length >= 1;
  }

  isSingleDonorSelected(): boolean {
    return this.selectedRows.length === 1;
  }

  showDonorGivingHistory(rowData: any) {
    this.servicesearch.emitShowDonorGivingHistory(rowData.DonorID);
    this.visibleDonorGivingHistory = true;
  }

  isDisabledCheckbox(modelItem: any): boolean {
    return (
      this.selectedRows.length === 2 &&
      this.selectedRows.indexOf(modelItem) === -1
    );
  }

  onSelectDonor(): void {
    if (this.selectedRows.length === 1) {
      this.servicesearch.emitDonorSelected(this.selectedRows[0]);
    } else if (this.selectedRows.length > 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Selection',
        detail: 'Please select only one donor.',
      });
    }
  }

  getSeverityAndValue(status: string): {
    severity:
      | 'success'
      | 'secondary'
      | 'info'
      | 'warning'
      | 'danger'
      | 'contrast';
    value: string;
  } {
    let severity:
      | 'success'
      | 'secondary'
      | 'info'
      | 'warning'
      | 'danger'
      | 'contrast' = 'secondary'; // default value
    let value = status;
    switch (status) {
      case 'Unapproved':
        severity = 'danger';
        value = 'Unapproved';
        break;
      case 'Partial':
        severity = 'warning';
        value = 'Partial';
        break;
      case 'Approved':
        severity = 'success';
        value = 'Approved';
        break;
      case 'Paid':
        severity = 'info';
        value = 'Paid';
        break;
      default:
        severity = 'secondary';
        value = 'Unknown';
    }
    return { severity, value };
  }
  onCancel(): void {
    this.selectedRows = [];
    this.messageService.add({
      severity: 'info',
      summary: 'Cancelled',
      detail: 'Selection has been cancelled.',
    });
  }

  openAddDonorDialog(donorId: any) {
    this.selectedDonorId = donorId;
    this.showDialog = true;
  }
  openEditDonationDialog(rowData: any) {
    if(this.showInDialog)
    {
      this.selectedDonationId =rowData.DonationID;
      this.showAddDonationCardDialog = true;
    }
    else {
      this.router.navigate(['/vortex/donations/donation-card'], {
        queryParams: { fromSearchDonorID: rowData.DonationID }
      });
    }
  }

  onAddDonation() {
    this.router.navigate(['vortex/donations/add-new-donation'], {
      queryParams: { source: 'donationSearch' }
    });
  }

  openAddDonationCardDialog(donationId: any) {
    this.selectedDonationId = donationId;
    this.showAddDonationCardDialog = true;
  }

  handleCancel(){
    // this.showAddDonationDialog=false;
  }

  deleteDonation(rowData: any) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this donation?",
      header: 'Confirm Action',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-outlined",
      accept: () => {
        if(rowData.BatchProcessed === "1") { 
          this.messageService.add({
            severity: 'error',
            summary: 'Deletion Failed',
            detail: `You cannot delete a processed donation: ${rowData.DonationID}.`
          });
        }
        else {
            console.debug(`Deleting donation with ID: ${rowData.DonationID}`);
            let batchID : number | null= Number.isInteger(+rowData.DepositBatchID) && rowData.DepositBatchID.trim() !=="" ? +rowData.DepositBatchID : null;
            this.serverClient.deleteDonation(batchID, rowData.DonationID).subscribe({
              next: () => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Deletion Successful',
                  detail: `Successfully deleted donation ${rowData.DonationID}.`
                });
                this.onSearch(); // Refresh the table
              },
              error: (err) => {
                console.error('Error deleting donation:', err);
                this.messageService.add({
                  severity: 'error',
                  summary: 'Deletion Failed',
                  detail: 'Failed to delete the donation.'
                });
              }
            });
          }
        },
        reject: () => {
        }
      });
  }

  filterChanged(){
    const multiSelects=[
      this.selectedStates,
      this.selectedFundCodes,
      this.selectedFundraisers,
      this.selectedSources,
      this.selectedEvents,
    ]
    const  isMultiSelects =multiSelects.some(f => f && f.length > 0);
    const isTextFilters= Object.values(this.textFilters || {}) .some(v => v && v.trim().length > 0);
    this.isFilterActive = this.hasDateFilter || this.hasAmountFilter || isMultiSelects || isTextFilters  || (typeof this.filterValue?.value === 'string' && this.filterValue.value.trim() !== '' );
  }

  // Range Filters Code
  getBlankFilter(obj: any): FilterModel {
    let filterModel: FilterModel = new FilterModel();
    filterModel.op = "equals";
    if (obj.displayColumnType.columnType === "AmountFilter" ||
      obj.displayColumnType.columnType === "DateFilter") {
      filterModel.ops = [
        { label: 'Equals', value: 'Equals' },
        { label: 'Greater Than', value: 'gt' },
        { label: 'Greater Than Or Equal To', value: 'gte' },
        { label: 'Less Than', value: 'lt' },
        { label: 'Less Than Or Equal To', value: 'lte' },
        { label: 'Between', value: 'between' }
      ];
      filterModel.options = obj.options || [];
      filterModel.dataType = obj.displayColumnType.columnType === 'DateFilter' ? "date" : "number";

      delete obj.options;
      return filterModel as FilterModel;
    }
    return filterModel;
  }

  updateFilter(ref: any, att: string, val: any) {
    ref.filterModel[att] = (val.value ? val.value : val);
  }

  hideAllOpenOpMenus() {
    this.selectedColumns.forEach(
      (i: DisplayColumn) => {
        i.filterModel.isMenuOpen = false;
      }
    );
  }

  toggleMenu(col: DisplayColumn) {
    if (col.filterModel.isMenuOpen === false) {
      this.hideAllOpenOpMenus();
    }
    col.filterModel.isMenuOpen = !col.filterModel.isMenuOpen;
  }

  popupMenuClickHandler(col: DisplayColumn, op: any) {
    col.filterModel.op = op.value;
    if (col.filterModel.op !== 'between') { col.filterModel.isMenuOpen = false }
  }
  onTableFilter(e: any) {
    const filters = this.resultstable.filters;
  }

  getSanitizedColumnName(col: any): string {
  return (col?.columnName || 'unknown').toLowerCase().replace(/\s+/g, '-');
  }

  ngDoCheck(): void {
    this.hasAmountFilter = false;
    this.hasDateFilter = false;
    
    this.selectedColumns.forEach(i => {
      const type = i.displayColumnType.columnType;
      const from = i.filterModel.from;
      const hasOptions = i.filterModel.options?.length;
    
      if ((hasOptions || type === "AmountFilter") && from)
        this.hasAmountFilter = true;
    
      if ((hasOptions || type === "DateFilter") && from)
        this.hasDateFilter = true;
     
      this.filterChanged();
    });
  }
}
